import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AppTableComponent } from '../core/common/app-table/app-table.component';
import { RowsRenderDirective } from '../core/common/app-table/rows-render';
import { AppSelectDepartmentsComponent } from '../core/common/app-select-departments/app-select-departments.component';
import { AppSelectOrganizesComponent } from '../core/common/app-select-organizes/app-select-organizes.component';
import { SrcPipe } from '../core/common/src.pipe';

// i18n
import { TranslateModule } from '@ngx-translate/core';
import { AppSelectMenusComponent } from '../core/common/app-select-menus/app-select-menus.component';
import { AppSelectIconsComponent } from '../core/common/app-select-icons/app-select-icons.component';
import { AppTreeMenusComponent } from '../core/common/app-tree-menus/app-tree-menus.component';
import { AppSelectDepartmentUsersComponent } from '../core/common/app-select-department-users/app-select-department-users.component';
import { AppSelectAreasComponent } from '../core/common/app-select-areas/app-select-areas.component';

import { chatDatePipe } from '../core/common/chat.date.pipe';


//ng-zorro-antd
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBackTopModule } from 'ng-zorro-antd/back-top';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { AppUploadFileComponent } from '../core/common/app-upload-file/app-upload-file.component';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { DragMoveDirective } from '../core/common/directive/drag.move.directive';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/compiler';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { UEditorModule } from 'ngx-ueditor';
import { ApiService } from '../core/net/apiRoute';
import { environment } from 'src/environments/environment';
import { FileSizePipe } from '../core/common/filesize.pipe';
import { AppSelectTreeComponent } from '../core/common/app-select-tree/app-select-tree.component';
import { AppSelectComponent } from '../core/common/app-select/app-select.component';
import { AppAMapComponent } from '../core/common/app-amap/app-amap.component';
export const SHARED_ZORRO_MODULES = [
  NzLayoutModule,
  NzButtonModule,
  NzMessageModule,
  NzNotificationModule,
  NzBackTopModule,
  NzDropDownModule,
  NzGridModule,
  NzCarouselModule,
  NzCheckboxModule,
  NzToolTipModule,
  NzPopoverModule,
  NzSelectModule,
  NzIconModule,
  NzAffixModule,
  NzBadgeModule,
  NzAlertModule,
  NzModalModule,
  NzTableModule,
  NzDrawerModule,
  NzTabsModule,
  NzInputModule,
  NzDatePickerModule,
  NzTagModule,
  NzInputNumberModule,
  NzBreadCrumbModule,
  NzStepsModule,
  NzListModule,
  NzTreeModule,
  NzSwitchModule,
  NzRadioModule,
  NzFormModule,
  NzAvatarModule,
  NzCardModule,
  NzSpinModule,
  NzDividerModule,
  NzSliderModule,
  NzResultModule,
  NzTreeSelectModule,
  NzPopconfirmModule,
  NzCollapseModule,
  NzUploadModule,
  NzTransferModule,
  NzCascaderModule,
  NzProgressModule,
  NzEmptyModule,
  NzImageModule,
  NzResizableModule,
  NzTimePickerModule
];

const THIRDMODULES = [
  TranslateModule
];
// #endregion

// #region your componets & directives
const COMPONENTS = [
  AppTableComponent,
  AppSelectDepartmentsComponent,
  AppSelectOrganizesComponent,
  AppSelectMenusComponent,
  AppSelectIconsComponent,
  AppTreeMenusComponent,
  AppSelectDepartmentUsersComponent,
  AppSelectAreasComponent,
  AppUploadFileComponent,
  AppSelectTreeComponent,
  AppSelectComponent,
  AppAMapComponent
];

const DIRECTIVES = [SrcPipe,RowsRenderDirective,chatDatePipe,DragMoveDirective,FileSizePipe];
// #endregion

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UEditorModule.forRoot({
      js: [
        `./assets/ueditor/aliyun-oss-sdk.min.js`,
        `./assets/ueditor/ueditor.config.js`,
        `./assets/ueditor/ueditor.all.js`,
      
      ],
      // 默认前端配置项
      options: {
        zIndex: 5000,
        UEDITOR_HOME_URL: '/assets/ueditor/',
        serverUrl: ApiService.UeditorUpload,
        aliyunOSS:environment.aliyunOSS
      }
    }),
    RouterModule,
    ReactiveFormsModule,
    // third libs
    ...THIRDMODULES,
    ...SHARED_ZORRO_MODULES
    
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
   
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // third libs
    ...THIRDMODULES,
    ...SHARED_ZORRO_MODULES,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    UEditorModule
  ],
  providers:[
    FileSizePipe,
    SrcPipe
  ]
 
})
export class SharedModule {}
